import { useEffect, useState } from "react";
import { Dashboard as NewDashboard } from "@/components/Dashboard/Dashboard";
import { useStore } from "@/stores/useStore";
import { Loading } from "@/components/Page/Loading";
import { useLayouts } from "@/hooks/useLayouts";
import { useAuth } from "@/hooks/store/useAuth";
import { Button } from "@/components/Base/Button";
import { useHeaderContext } from "@/hooks/useHeaderContext";
import { DashboardHeader } from "@/components/Page/Header/DashboardHeader";
import { MyCustomerUpdateToastManager } from "@/components/CustomerUpdate/MyCustomerUpdateToastManager";
import { MyOverdueTaskToastManager } from "@/components/Dashboard/components/MyOverdueTaskToastManager";
import { AutomationToastManager } from "@/components/Dashboard/components/AutomationToastManager";
import { FeatureFlagged } from "@/components/Common/FeatureFlagged";
import { FEATURE_FLAGS } from "@/types/v2";

export const DashboardContainer = () => {
  const { logout } = useAuth();
  const [loaded, setLoaded] = useState(false);
  const { dashboardLayoutId, syncWithSource } = useStore();

  const { setHeaderContent } = useHeaderContext();

  useEffect(() => {
    setHeaderContent(<DashboardHeader />);

    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  const { layouts: layoutsData } = useLayouts();

  // LAYOUT MANAGEMENT
  const [selectedLayoutId, setSelectedLayoutId] = useState<string>();

  useEffect(() => {
    if (layoutsData) {
      new Promise((r) => setTimeout(r, 1000)).then(() => setLoaded(true));
    }
  }, [layoutsData]);

  useEffect(() => {
    if (dashboardLayoutId && layoutsData && layoutsData.length > 0) {
      const layout =
        layoutsData.find(
          (layout) => Object.keys(layout)[0] === dashboardLayoutId
        ) ?? layoutsData[0];
      if (!layout) return setSelectedLayoutId(undefined);
      setSelectedLayoutId(dashboardLayoutId);
    }
  }, [layoutsData, dashboardLayoutId]);

  const handleSignOut = () => {
    logout();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      syncWithSource();
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [syncWithSource]);

  if (!layoutsData) {
    return (
      <div className="mt-8 flex flex-col items-center justify-center gap-4 text-3xl">
        <div>
          Loading Layouts. If this action takes too long. Click the button below
          and refresh the page.
        </div>
        <Button variant={"accent"} onClick={handleSignOut}>
          Logout
        </Button>
      </div>
    );
  }

  if (!loaded) return <Loading />;

  return (
    <>
      <FeatureFlagged feature={FEATURE_FLAGS.isCustomerUpdatesEnabled}>
        <MyCustomerUpdateToastManager />
      </FeatureFlagged>
      <FeatureFlagged feature={FEATURE_FLAGS.isTasksTabEnabled}>
        <MyOverdueTaskToastManager />
      </FeatureFlagged>
      <AutomationToastManager />
      {selectedLayoutId ? (
        <NewDashboard selectedLayoutId={selectedLayoutId} />
      ) : (
        <div className="mt-20 flex flex-col items-center justify-center text-3xl">
          <p>Please select a layout to display</p>
        </div>
      )}
    </>
  );
};
